export enum DefaultSubMenuItems {
  Registrations = 'registrations',
  Attachments = 'attachments',
  Comment = 'comment',
}
